import axiosIns from "@/libs/axios";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchMemberContracts(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/member/contract/list", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    updateMemberContract(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/member/contract", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    exportMemberContract(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/member/contract/export", { params: queryParams, responseType: 'blob'} )
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchMembershipLogs(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/member/membership_log/list", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  }
};
